export const GET_HOTSPOT_STATUS = "GET_HOTSPOT_STATUS";
export const SET_HOTSPOT_STATUS = "SET_HOTSPOT_STATUS";
